import { type Locale } from '@/providers/Locale/types'

type TextFields = 'published' | 'updated' | 'yesterday'

export const i18n: Record<Locale, Record<TextFields, string>> = {
    en: {
        published: 'Published',
        updated: 'Updated',
        yesterday: 'Yesterday',
    },
    es: {
        published: 'Publicado',
        updated: 'Actualizado',
        yesterday: 'Ayer',
    },
    fr: {
        published: 'Publié',
        updated: 'Mis à jour',
        yesterday: 'Hier',
    },
    de: {
        published: 'Veröffentlicht',
        updated: 'Aktualisiert',
        yesterday: 'Gestern',
    },
}
